import Message from 'owa-service/lib/contract/Message';
import { action } from 'satcheljs/lib/legacy';
import { getStore as getReadingPaneStore } from '../store/Store';
import { ClientItem, SmartTimeSuggestion } from 'owa-mail-store';
import { lazyGetToCcRecipientsForReply } from 'owa-mail-compose-actions';
import createEditorViewState from 'owa-editor/lib/utils/createEditorViewState';

export default action('setCalendarInlineComposeViewState')(
    async function setCalendarInlineComposeViewState(
        item: ClientItem,
        smartTimeSuggestion: SmartTimeSuggestion
    ) {
        const message = item as Message;
        const getToCcRecipientsForReply = await lazyGetToCcRecipientsForReply.import();
        const [toRecipients, ccRecipients] = await getToCcRecipientsForReply(
            message,
            true /*isReplyAll*/
        );
        getReadingPaneStore().conversationReadingPaneViewState.calendarInlineComposeViewState = {
            ...createEditorViewState(),
            referenceItemId: item.ItemId.Id,
            subject: item.Subject,
            location: null,
            smartTimeSuggestion: smartTimeSuggestion,
            toRecipients: toRecipients,
            ccRecipients: ccRecipients,
        };
    }
);
